module.exports = __webpack_public_path__ + "img/compare1.bc77e809.png";